// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ON8z","questions":"styles_questions__1zEJ9","footer":"styles_footer__33n2N"};